import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface EnhancedForumStats {
  total_topics: number;
  total_posts: number;
  total_members: number;
  topics_today: number;
  posts_today: number;
  members_today: number;
  topics_this_week: number;
  posts_this_week: number;
  members_this_week: number;
  most_active_category: string | null;
  top_poster: string | null;
}

export const useEnhancedForumStats = () => {
  return useQuery({
    queryKey: ['enhanced-forum-stats'],
    queryFn: async (): Promise<EnhancedForumStats> => {
      // RPC not available - return default values
      return {
        total_topics: 0,
        total_posts: 0,
        total_members: 0,
        topics_today: 0,
        posts_today: 0,
        members_today: 0,
        topics_this_week: 0,
        posts_this_week: 0,
        members_this_week: 0,
        most_active_category: null,
        top_poster: null,
      };
    },
    enabled: false, // Disable query since RPC doesn't exist
  });
};